export const profileMenu = [
    { label: "My Profile", path: "/profile" },
    { label: "My Orders", path: "/my-orders" },
    { label: "My Invoice", path: "/invoice-list" },
    { label: "My Quotation", path: "/quotation-list" },
    { label: "Sign Out", path: "/signout" },   
  ]